import { ReactElement } from 'react';
import { ContactInformation } from '../ContactInformation';

const SubscribeMessage = (): ReactElement => (
  <p>
    {
      'Avoid missing our indispensable insights by upgrading your account. To learn more, contact your account representative at '
    }
    <ContactInformation />.
  </p>
);

export default SubscribeMessage;
